














import Vue from "vue";
import iwInputCheckboxGroup from "@/encoding/components/buildingBlocks/InputCheckboxGroup.vue";

export default Vue.extend({
    components: {
        iwInputCheckboxGroup: iwInputCheckboxGroup
    },
    data: function () {
        return {
            pathInStoreIsFacingStreet: "property.land.isFacingStreet",
            pathInStoreHasPlotToRear: "property.land.hasPlotToRear",
            pathInStoreIsFlat: "property.land.isFlat",
            pathInStoreIsWooded: "property.land.isWooded",
            checkboxes: [
                {
                    value: "isFacingStreet",
                    label: "facing_street"
                },
                {
                    value: "isFlat",
                    label: "land_is_flat"
                },
                {
                    value: "hasPlotToRear",
                    label: "land_plot_to_rear"
                },
                {
                    value: "isWooded",
                    label: "is_land_wooded"
                }
            ]
        };
    },
    computed: {
        isDisplayed: function(): boolean {
            return ["HOUSE", "OFFICE", "INDUSTRY", "COMMERCIAL", "LAND", "OTHER"].indexOf(this.getPropertyType()) !== - 1;
        },
        getErrorMessage: function(): string|null {
            return this.$store.getters["FormModule/getErrorObjectByPath"](this.pathInStoreIsFacingStreet) ||
                this.$store.getters["FormModule/getErrorObjectByPath"](this.pathInStoreHasPlotToRear) ||
                this.$store.getters["FormModule/getErrorObjectByPath"](this.pathInStoreIsFlat);
        },
        valueChecked: function(): Array<string> | void{
            const arrayValues = [];
            if (this.$store.getters["FormModule/getValue"](this.pathInStoreIsFacingStreet)) {
                arrayValues.push("isFacingStreet");
            }
            if (this.$store.getters["FormModule/getValue"](this.pathInStoreIsFlat)) {
                arrayValues.push("isFlat");
            }
            if (this.$store.getters["FormModule/getValue"](this.pathInStoreHasPlotToRear)) {
                arrayValues.push("hasPlotToRear");
            }
            if (this.$store.getters["FormModule/getValue"](this.pathInStoreIsWooded)) {
                arrayValues.push("isWooded");
            }
            return arrayValues;
        },
    },
    mounted: function() {
        if (this.isDisplayed) {
            if(this.$store.getters["FormModule/getValue"](this.pathInStoreIsFacingStreet) == null) {
                this.$store.dispatch("FormModule/addValue", {path: this.pathInStoreIsFacingStreet, value: false});
            }
            if(this.$store.getters["FormModule/getValue"](this.pathInStoreIsFlat) == null) {
                this.$store.dispatch("FormModule/addValue", {path: this.pathInStoreIsFlat, value: false});
            }
            if(this.$store.getters["FormModule/getValue"](this.pathInStoreHasPlotToRear) == null) {
                this.$store.dispatch("FormModule/addValue", {path: this.pathInStoreHasPlotToRear, value: false});
            }
            if(this.$store.getters["FormModule/getValue"](this.pathInStoreIsWooded) == null) {
                this.$store.dispatch("FormModule/addValue", {path: this.pathInStoreIsWooded, value: false});
            }
        } else {
            this.$store.commit("FormModule/deleteValue", this.pathInStoreIsFacingStreet);
            this.$store.commit("FormModule/deleteValue", this.pathInStoreIsFlat);
            this.$store.commit("FormModule/deleteValue", this.pathInStoreHasPlotToRear);
            this.$store.commit("FormModule/deleteValue", this.pathInStoreIsWooded);
        }
    },

    methods: {
        updateValue: function(selectedValues: Array<string>): void {
            this.$store.dispatch("FormModule/addValue", {
                path: this.pathInStoreIsFacingStreet,
                value: selectedValues.includes("isFacingStreet")
            });

            this.$store.dispatch("FormModule/addValue", {
                path: this.pathInStoreIsFlat,
                value: selectedValues.includes("isFlat")
            });

            this.$store.dispatch("FormModule/addValue", {
                path: this.pathInStoreHasPlotToRear,
                value: selectedValues.includes("hasPlotToRear")
            });

            this.$store.dispatch("FormModule/addValue", {
                path: this.pathInStoreIsWooded,
                value: selectedValues.includes("isWooded")
            });

        }
    },
});
